import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TrackerTable = _resolveComponent("TrackerTable")
  const _component_TrackerModal = _resolveComponent("TrackerModal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TrackerTable, {
      widget: $props.widget,
      onExpand: $options.expand
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", { expanded: false })
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["widget", "onExpand"]),
    (_ctx.mount_modal)
      ? (_openBlock(), _createBlock(_component_TrackerModal, {
          key: 0,
          ref: "modal",
          widget: $props.widget,
          onAfterLeave: _cache[0] || (_cache[0] = $event => (_ctx.mount_modal = false))
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", { expanded: true })
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["widget"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}